import { useEffect, useState } from 'react';

/* ==========================================================================
   Tela pequena e relógio do Atendimento

   `useMediaQuery` acompanha uma media query (a tela Atendimento troca o
   lado a lado pela lista em tela cheia abaixo de 768 px). `useTick` faz a
   lista e o cabeçalho recontarem a espera sem esperar uma nova leitura.
   ========================================================================== */

/** Abaixo disto a lista ocupa a tela e a conversa abre em tela cheia com "Voltar". */
export const SMALL_SCREEN_QUERY = '(max-width: 767px)';

function matches(query: string): boolean {
  try {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;
  } catch {
    return false;
  }
}

export function useMediaQuery(query: string): boolean {
  const [value, setValue] = useState(() => matches(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    let list: MediaQueryList;
    try {
      list = window.matchMedia(query);
    } catch {
      return;
    }
    const onChange = () => setValue(list.matches);
    onChange();
    list.addEventListener?.('change', onChange);
    return () => list.removeEventListener?.('change', onChange);
  }, [query]);

  return value;
}

/** Um número que muda a cada `intervalMs`, para recontar a espera. */
export function useTick(intervalMs = 30_000): number {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return tick;
}
